import { combineReducers } from 'redux';

const passwordResetOpen = (state = false, action) => {
  switch (action.type) {
    case 'SET_MODAL_PASSWORD_RESET_OPEN':
      return true;
    case 'SET_MODAL_LOGIN_FORM_OPEN':
    case 'SET_MODAL_PASSWORD_RESET_CLOSED':
    case 'SET_MODAL_PROGRAM_EDIT_OPEN':
    case 'SET_MODAL_HELP_OPEN':
    case 'SET_MODAL_TERMS_OPEN':
      return false;
    default:
      return state;
  }
};

const LoginFormOpen = (state = false, action) => {
  switch (action.type) {
    case 'SET_MODAL_LOGIN_FORM_OPEN':
      return true;
    case 'SET_MODAL_LOGIN_FORM_CLOSED':
    case 'SET_MODAL_PASSWORD_RESET_OPEN':
    case 'SET_MODAL_PROGRAM_EDIT_OPEN':
    case 'SET_MODAL_HELP_OPEN':
    case 'SET_MODAL_TERMS_OPEN':
      return false;
    default:
      return state;
  }
};

const resetPassword = (state = false, action) => {
  switch (action.type) {
    case 'SET_MODAL_RESET_PASSWORD_FORM_OPEN':
      return action.payload;
    case 'SET_MODAL_LOGIN_FORM_CLOSED':
    case 'SET_MODAL_PASSWORD_RESET_OPEN':
    case 'SET_MODAL_PROGRAM_EDIT_OPEN':
    case 'SET_MODAL_HELP_OPEN':
    case 'SET_MODAL_TERMS_OPEN':
      return false;
    default:
      return state;
  }
};

const programEditOpen = (state = false, action) => {
  switch (action.type) {
    case 'SET_MODAL_PROGRAM_EDIT_OPEN':
      return true;
    case 'SET_MODAL_LOGIN_FORM_OPEN':
    case 'SET_MODAL_PROGRAM_EDIT_CLOSED':
    case 'SET_MODAL_PASSWORD_RESET_OPEN':
    case 'SET_MODAL_HELP_OPEN':
    case 'SET_MODAL_TERMS_OPEN':
      return false;
    default:
      return state;
  }
};

const helpOpen = (state = false, action) => {
  switch (action.type) {
    case 'SET_MODAL_HELP_OPEN':
      return true;
    case 'SET_MODAL_LOGIN_FORM_OPEN':
    case 'SET_MODAL_HELP_CLOSED':
    case 'SET_MODAL_PROGRAM_EDIT_OPEN':
    case 'SET_MODAL_PASSWORD_RESET_OPEN':
    case 'SET_MODAL_TERMS_OPEN':
      return false;
    default:
      return state;
  }
};

const confirmOpen = (state = false, action) => {
  switch (action.type) {
    case 'SET_MODAL_CONFIRM_OPEN':
      return true;
    case 'SET_MODAL_LOGIN_FORM_OPEN':
    case 'SET_MODAL_CONFIRM_CLOSED':
    case 'SET_MODAL_HELP_OPEN':
    case 'SET_MODAL_PROGRAM_EDIT_OPEN':
    case 'SET_MODAL_PASSWORD_RESET_OPEN':
    case 'SET_MODAL_TERMS_OPEN':
      return false;
    default:
      return state;
  }
};

const termsOpen = (state = false, action) => {
  switch (action.type) {
    case 'SET_MODAL_TERMS_OPEN':
      return true;
    case 'SET_MODAL_LOGIN_FORM_OPEN':
    case 'SET_MODAL_TERMS_CLOSED':
    case 'SET_MODAL_HELP_OPEN':
    case 'SET_MODAL_PROGRAM_EDIT_OPEN':
    case 'SET_MODAL_PASSWORD_RESET_OPEN':
    case 'SET_MODAL_CONFIRM_OPEN':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  passwordResetOpen,
  programEditOpen,
  helpOpen,
  confirmOpen,
  termsOpen,
  LoginFormOpen,
  resetPassword
});

export const getPasswordModalOpen = (state) => state.passwordResetOpen;
export const getLoginFormModalOpen = (state) => state.LoginFormOpen;
export const getProgramModalOpen = (state) => state.programEditOpen;
export const getHelpModalOpen = (state) => state.helpOpen;
export const getConfirmModalOpen = (state) => state.confirmOpen;
export const getTermsModalOpen = (state) => state.termsOpen;
